const state = {
  token: null,
  loginInfo: null,
  id: null
};

const mutations = {
  setToken (state, token) {
    state.token = token;
  },
  setLoginInfo (state, loginInfo) {
    state.loginInfo = loginInfo;
  },
  setId (state, id) {
    state.id = id
  }
};

export default {
  namespaced: true,
  state,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js